const FormResources = {
    form_data:
    {
        name: '',
        description: '',
        permissions_action: 3,
        template_permissions: []
    },

    form_format: 
    [
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  200,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  200,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
    ]
}

export default FormResources;